// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const DocumentStackIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="DocumentStackIcon" ref={forwardedRef} {...props}>
      <path d="M14.313 2.25h-6.06a1 1 0 0 0-1 1v.707l-4.8 1.496a1 1 0 0 0-.66 1.252l3.56 11.46a1 1 0 0 0 1.25.658l8.258-2.573h1.89a1 1 0 0 0 1-1V5.36zm1.937 5v7.5H8.754v-11h3.748v3.5zm-2.248-3.258 1.943 1.758h-1.943zM3.374 6.736l3.88-1.208v9.722a1 1 0 0 0 1 1h1.564l-3.182.991z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const DocumentStackIcon = /* @__PURE__ */ Object.assign(
  DocumentStackIconComponent,
  { displayName: 'DocumentStackIcon' },
);
